import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section 
      className="hero" 
      id="hero"
      style={{
        backgroundImage: `url('/fotky/hero2.png')`
      }}
    >
      <div className="hero-content">
        <h1 className="hero-title">Opravna a servis<br />jízdních kol</h1>
        <p className="hero-subtitle">Profesionální servis a opravy kol v Hradci Králové</p>
        <div className="hero-address">
          <p>Čelakovského 501/6 - peší zóna, centrum</p>
          <p>500 02 Hradec Králové</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;

